const PasswordStrengthIndicator = ({
  password,
}: PasswordStrengthIndicatorProps) => {
  const calculateStrength = (password: string): number => {
    if (!password) return 0;

    let strength = 0;

    // Length check
    if (password.length >= 8) strength++;

    // Contains number
    if (/\d/.test(password)) strength++;

    // Contains lowercase and uppercase
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) strength++;

    // Contains special character
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) strength++;

    return strength;
  };

  const strength = calculateStrength(password);

  const getSegmentColor = (segmentIndex: number) => {
    if (password.length === 0) return "bg-gray-200";
    if (segmentIndex >= strength) return "bg-gray-200";

    switch (strength) {
      case 1:
        return "bg-red-500";
      case 2:
        return "bg-orange-500";
      case 3:
        return "bg-yellow-500";
      case 4:
        return "bg-green-500";
      default:
        return "bg-gray-200";
    }
  };

  return (
    <div className="w-full space-y-1">
      <div className="flex gap-2 w-full">
        {[0, 1, 2, 3].map((index) => (
          <div
            key={index}
            className={`h-1 flex-1 rounded-full transition-colors duration-300 ${getSegmentColor(
              index
            )}`}
          />
        ))}
      </div>
      <p className="text-xs text-gray-500 mt-1">
        {password.length === 0 && "Password strength indicator"}
        {password.length > 0 && strength === 1 && "Weak password"}
        {password.length > 0 && strength === 2 && "Fair password"}
        {password.length > 0 && strength === 3 && "Good password"}
        {password.length > 0 && strength === 4 && "Strong password"}
      </p>
    </div>
  );
};

export default PasswordStrengthIndicator;

interface PasswordStrengthIndicatorProps {
  password: string;
}
